/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import {
  Button,
  ChevronRightIcon,
  Flex,
  StarIcon,
} from '@bottlebooks/gatsby-theme-base';
import ExhibitorListRowSmall from '@bottlebooks/gatsby-theme-event/src/components/SiteSearch/ExhibitorListRowSmall';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import { jsx } from 'theme-ui';
import { useFavorite } from '../useFavorite';

/**
 *
 * @param {{
 *  exhibitor: Parameters<ExhibitorListRowSmall>[0]["exhibitor"] & { brandId?: string; [x: string]: any } | undefined;
 *  onClick?: () => void;
 *  to?: string;
 *  listId?: string;
 *  [x: string]: any;
 * }} props
 * @returns
 */
export default function FavoriteExhibitor({
  exhibitor,
  onClick,
  listId,
  to,
  ...rest
}) {
  const favorite = useFavorite(
    exhibitor?.brandId
      ? { type: 'registration', id: exhibitor.brandId }
      : undefined
  );
  const link = useLink();
  if (!exhibitor) return null;
  return (
    <Flex
      align="center"
      sx={favorite.isSet && { backgroundColor: 'background' }}
      {...rest}
    >
      <ExhibitorListRowSmall
        exhibitor={exhibitor}
        to={to}
        onClick={onClick}
        sx={{
          flexGrow: 1,
          paddingLeft: 2,
          ':hover': { backgroundColor: 'inherit' },
        }}
      />
      <Button
        variant="text"
        onClick={
          favorite.mayToggle
            ? () => {
                if (favorite.isSet) return favorite.unset();
                return favorite.set(listId ? { listId } : undefined);
              }
            : undefined
        }
      >
        <StarIcon
          variant={favorite.isSet ? 'filled' : 'hollow'}
          sx={{
            color: favorite.isSet ? 'primary' : 'lightestText',
            transition: 'color',
            marginTop: 1,
            ':hover': { color: 'secondary' },
          }}
        />
      </Button>

      <Button
        variant="text"
        to={
          exhibitor.brandId &&
          link.exhibitor({ exhibitorId: exhibitor.brandId })
        }
      >
        <ChevronRightIcon />
      </Button>
    </Flex>
  );
}
